import { createSelector } from 'reselect';
import browserUtils from '../utils/browserUtils';

const getApp = (state) => state.app;

const AppSelectors = {
  makeApp: createSelector([getApp], (app) => app),
  makeBrand: createSelector([getApp], (app) => app.brand),
  makeCookieEnabledServices: createSelector([getApp], (app) => app.cookieEnabledServices),
  makeHostname: createSelector([getApp], (app) => app.hostname),
  makeHostApp: createSelector([getApp], (app) => app.cookieEnabledServices.hostApp),
  makeAppConfig: createSelector([getApp], (app) => app.appConfig),
  makeUserAgent: createSelector([getApp], (app) => app.userAgent),
  makeIsWizardView: createSelector([getApp], (app) => app.isWizardView),
  makeIsFooterlessView: createSelector([getApp], (app) => app.isFooterlessView),
  makeIsDev: createSelector([getApp], (app) => app.isDev),
  makeIsOnline: createSelector([getApp], (app) => app.isOnline),
  makeIsMobile: createSelector([getApp], (app) => app.isMobile),
  makeIsScreenMobile: createSelector([getApp], (app) => {
    const screenType = browserUtils.screen.type(app.constellationScreenSize);
    return screenType === browserUtils.screenType.MOBILE;
  }),
  makeIsScreenTablet: createSelector([getApp], (app) => {
    const screenType = browserUtils.screen.type(app.constellationScreenSize);
    return screenType === browserUtils.screenType.TABLET;
  }),
  makeIsScreenDesktop: createSelector([getApp], (app) => {
    const screenType = browserUtils.screen.type(app.constellationScreenSize);
    return screenType === browserUtils.screenType.DESKTOP;
  }),
  makeIsScreenLg: createSelector([getApp], (app) => app.constellationScreenSize === browserUtils.screenSize.LG),
  makeIsScreenLgGTE: createSelector([getApp], (app) => {
    const screenType = app.constellationScreenSize;
    return (
      screenType === browserUtils.screenSize.LG ||
      screenType === browserUtils.screenSize.XL ||
      screenType === browserUtils.screenSize.XXL
    );
  }),
  makeIsScreenXlGTE: createSelector([getApp], (app) => {
    const screenType = app.constellationScreenSize;
    return screenType === browserUtils.screenSize.XL || screenType === browserUtils.screenSize.XXL;
  }),
  makeIsScreenXxlGTE: createSelector([getApp], (app) => {
    const screenType = app.constellationScreenSize;
    return screenType === browserUtils.screenSize.XXL;
  }),
  makeIp: createSelector([getApp], (app) => app.ip),
  makeFullReqIps: createSelector([getApp], (app) => app.fullReqIps),
  makeIsRunningInProd: createSelector([getApp], (app) => app.isRunningInProd),
  makeSupportsWebp: createSelector([getApp], (app) => app.supportsWebp),
  makeTimeZone: createSelector([getApp], (app) => app.timeZone),
};

export default AppSelectors;
